// Presentation-only normalization. Do not invent a location or change job scope.
import {catalogLabel} from '../career/CareerCatalog';
export function jobLabel(value) {
  if (typeof value !== 'string') return '';
  const text=value.trim().replace(/\s+/g,' ');
  return !text || /^[\s/|\-–—]+$/.test(text) || /^(null|undefined)$/i.test(text) ? '' : text;
}

export function jobLocation(job,lang='tr') {
  const seen=new Set();
  return [job?.ilanIlceAdi,job?.ilanillerAdi,catalogLabel('country',job?.ilanUlkelerAdi,lang)].map(jobLabel).filter(text=>{
    if(!text)return false;
    const key=text.toLocaleLowerCase('tr-TR');
    if(seen.has(key))return false;
    seen.add(key);return true;
  }).join(' / ');
}

export function jobDeadline(value,locale) {
  const match=typeof value==='string'&&value.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  if(!match||Number(match[1])<1900)return '';
  const [year,month,day]=match.slice(1).map(Number), date=new Date(Date.UTC(year,month-1,day));
  if(date.getUTCFullYear()!==year||date.getUTCMonth()!==month-1||date.getUTCDate()!==day)return '';
  // A deadline is a calendar date, not a timestamp to shift into another day.
  return date.toLocaleDateString(locale,{timeZone:'UTC'});
}
